export default __webpack_public_path__ + "static/media/login.2a88ce0c.svg";